export default [
  {
    path: '/app/reports',
    name: 'ReportDashboard',
    component: () => import('@/views/Reports/Index.vue'),
    meta: {
      pageTitle: 'Raporlar',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
      resource: 'REPORTS',
      action: 'read',
    },
  },
]
